module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-ExtraBold.9f284b59.ttf";